<template>
    <v-row wrap class="pa-1 pa-sm-0 mt-3 grey lighten-4">
        <v-col cols="12" v-if="category">
            <grid-resources
                :heading="category.Name"
                :view-name="category.ViewName"
                :desc="category.Description"
                :hide-filter="category.HideFilter"
                :card-props="{ cardClass: category.CardClass, contain: category.ContainImg }"
                :limit="200" />
            <modal-details :modal-props="{ showImage: !category.ContainImg, viewName: category.ViewName }" />
        </v-col>
        <v-col cols="12" sm="11" md="10" lg="9" class="mx-auto py-5">
            <Footer />
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { Footer, GridResources  } from '@/components'
import { GET_CATEGORIES } from '@/store/action-types'
import ModalDetails from '@/components/ModalDetails'

export default {
    data: () => ({
        catName: '',
    }),
    components: {
        GridResources,
        ModalDetails,
        Footer,
    },
    async created () {
       await this.$store.dispatch(GET_CATEGORIES)
    },
    methods: {
    },
    computed: {
        ...mapState({
            users: state => state.user.all,
            categories: state => state.category.all,
            // dialogDetails: state => state.resource.dialogDetails,
        }),
        ...mapGetters([
            'isLoggedIn',
            'categoryByViewName',
        ]),
        category() {
            return this.categoryByViewName(this.$route.params.category)
        },
    }
}
</script>
<style scoped>
    .sticky-top {
        position: sticky;
        top: 70px;
        z-index: 3;
    }
</style>